export const CONNORS_APPLY_COMPANY_NAMES = [
  "Connor's Collective",
  "HiMatCha Cooporation Sedian Berhad (SDN BHD)",
];

export const CONNORS_APPLY_COMPANY_NAME = CONNORS_APPLY_COMPANY_NAMES[0];

export function requiresConnorsApplyConfirm(companyName) {
  if (!companyName || typeof companyName !== "string") {
    return false;
  }

  const normalizedName = companyName.trim().toLowerCase();

  return CONNORS_APPLY_COMPANY_NAMES.some(
    (name) => name.toLowerCase() === normalizedName
  );
}
